


/**
* Device Types within Admin Domain
*/
export enum DeviceTypes{
    /**
    * Android devices
    */
    Android = 0,
    /**
    * Apple/iOS devices
    */
    Apple = 1
}

